import { useRef } from 'react';

/**
 * The value as it was when `open` turned true, for as long as it stays true;
 * the live value while closed. For what a tour shows: the list it opened with
 * must not change under it while it is on screen.
 */
export function useLatchedWhileOpen<T>(open: boolean, value: T): T {
  const latched = useRef<{ value: T } | null>(null);
  if (!open) {
    latched.current = null;
    return value;
  }
  if (latched.current === null) latched.current = { value };
  return latched.current.value;
}
